import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/template-sub-section-elements"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const elementsApi = createApi({
    reducerPath: "elementsApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ["ElementsEditor"],
    endpoints: (builder) => ({
        getEditorElementData: builder.query({
            query: (id) => `/${id}/edit`,
            transformResponse: (response) => response.data,
        }),
        getElements: builder.query({
            query: ({ sectionId, movementId }) => `?sub-section-id=${sectionId}&movement-id=${movementId}`,
            transformResponse: (response) => response.data,
            providesTags: ["ElementsEditor"],
        }),
        createElementFromClipboard: builder.mutation({
            query: (obj) => ({
                url: `/create-from-clipboard`,
                method: "POST",
                body: obj,
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ["ElementsEditor"],
        }),
        createElement: builder.mutation({
            query: (obj) => ({
                url: `/`,
                method: "POST",
                body: obj,
            }),
            transformResponse: (response) => response.data,
            invalidatesTags: ["ElementsEditor"],
        }),
        changeElementDisplayOrder: builder.mutation({
            query: (obj) => ({
                url: `/change-display-order`,
                method: "POST",
                body: obj,
            }),
            transformResponse: (response) => response.data,
            // invalidatesTags: ["ElementsEditor"]
        }),
    }),
});

export const {
    useLazyGetEditorElementDataQuery,
    useLazyGetElementsQuery,
    useGetElementsQuery,
    useCreateElementFromClipboardMutation,
    useCreateElementMutation,
    useChangeElementDisplayOrderMutation,
} = elementsApi;
